import React, { useContext, useEffect, useState } from 'react';
import GroundSettlelmentTable from '../component/GroundSettlement/GroundSettllementTable';
import GroundSettlementFilter from '../component/GroundSettlement/GroundSettlementFilter';
import { AuthContext } from '../auth/ContextAuthentication';
import useAxiosConfig from '../config/AxiosConfig'; // Import the modal component
import { ErrorLoadingContext } from '../auth/ErrorLoadingContext';
import { Button, Pagination } from '@mui/material';
import AddReceiptGround from '../component/AddReceiptGround';
const GroundSettlement = () => {
  const axiosInstance = useAxiosConfig();
  const headerData = [
    'Ground Name',
    'Amount Pending',
    'Amount Paid',
    'Manager Name',
    'Total No. of Bookings',
    'Total Booking Value',
    // 'City',
    // 'Sports',
  ];

  const { setGroundData, adminRole } = useContext(AuthContext);

  const [totalPages, setTotalPages] = useState(false);
  const [sportId, setSportId] = useState('');
  const [page, setPage] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [onSearchChange, setOnSearchChange] = useState('');
  const [cityFilter, setCityFilter] = useState('All');
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info',
  });

  const { setLoading, setError } = useContext(ErrorLoadingContext);
  useEffect(() => {
    fetchGroundData();
  }, [startDate, endDate, onSearchChange, sportId, page, cityFilter]);

  // useEffect(() => {
  //   console.log("sport ID is ", sportId);
  // }, [sportId]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setOnSearchChange(searchValue);
    }, 2000);

    return () => clearTimeout(timer);
  }, [searchValue]);

  const handlePageChange = (event, page) => {
    setPage(page);
  };

  const fetchGroundData = async () => {
    setLoading(true);
    try {
      const baseUrl = '/api/admin/get-all-grounds-settelment';

      const queryParams = new URLSearchParams();
      if (startDate && endDate) {
        queryParams.append('startDate', startDate);
        queryParams.append('endDate', endDate);
      }
      queryParams.append('sportsId', sportId || '');
      queryParams.append('city', cityFilter || '');
      queryParams.append('groundName', onSearchChange || '');
      queryParams.append('page', page);
      const url = `${baseUrl}?${queryParams.toString()}`;
      const response = await axiosInstance.get(url);
      if (response.status === 200) {
        setGroundData(response.data.grounds);
        setTotalPages(response.data.totalPages);
        setLoading(false);
      }
    } catch (error) {
      setError('Error fetching data');
      setLoading(false);
    }
  };

  const handleSelectedSports = id => {
    setSportId(id);
  };
  const handleSelectedCity = id => {
    setCityFilter(id);
  };
  const handleDateValues = (label, value) => {
    if (label === 'startDate') {
      setStartDate(value);
    } else {
      setEndDate(value);
    }
  };

  const handleSearchValues = value => {
    setSearchValue(value);
  };

  const handleOpenAddDialog = () => {
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
  };

  const handleCloseNotification = () => {
    setNotification({ open: false, message: '', severity: 'info' });
  };

  return (
    <div className="flex flex-col">
      <h2 className="text-xl font-bold mb-10">Grounds Settlements</h2>
      <div className="absolute top-20 right-[4%] flex gap-5">
        {/* <div className="flex gap-5 justify-end mb-4"> */}

        {/* <Button
          variant="contained"
          color="success"
          onClick={handleOpenAddDialog}
          disabled={adminRole !== "Super Admin"}
          sx={{
            backgroundColor:
              adminRole === "Super Admin" ? "#0C7240" : "#B0B0B0",
            boxShadow: "none",
            "&:hover": {
              backgroundColor:
                adminRole === "Super Admin" ? "#0C7240" : "#B0B0B0",
              boxShadow: "none",
            },
            cursor: adminRole === "Super Admin" ? "pointer" : "not-allowed",
          }}
        >
          Add Receipt
        </Button> */}
      </div>
      <GroundSettlementFilter
        handleDateValues={handleDateValues}
        handleSelectedSports={handleSelectedSports}
        handleSelectedCity={handleSelectedCity}
        sportId={sportId}
        cityFilter={cityFilter}
        handleSearchValues={handleSearchValues}
        searchValue={searchValue}
      />
      <AddReceiptGround
        open={openAddDialog}
        onClose={handleCloseAddDialog}
        axiosInstance={axiosInstance}
        setNotification={setNotification}
        fetchGroundData={fetchGroundData}
      />
      <div>
        <GroundSettlelmentTable
          headerData={headerData}
          fetchGroundData={fetchGroundData}
          totalPages={totalPages}
          page={page}
          handleSelectedSports={handleSelectedSports}
          handleDateValues={handleDateValues}
          handleSearchValues={handleSearchValues}
        />
      </div>

      <div className="flex justify-center mt-1">
        <Pagination
          count={totalPages}
          page={page}
          onChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default GroundSettlement;
